import axios, { AxiosInstance, AxiosResponse } from "axios";
import { CreateReadingTacticInput, ReadingTactic } from "@/types/readingTactic";
import { client } from "@/api/client";
import { authHeaders } from "@/hoc/authHeaders";

export async function fetchReadingTactics(
  url: string
): Promise<ReadingTactic[]> {
  const headers = await authHeaders();
  const { data } = await client
    .get(url, {
      headers,
    })
    .catch((error) => {
      throw new Error(error.response.message);
    });
  return data;
}

export interface ReadingTacticRepository {
  createReadingTactic(reading_tactics: CreateReadingTacticInput): Promise<void>;
}

class OrganizationRepositoryImpl implements ReadingTacticRepository {
  private readonly client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this.client = client;
  }

  async createReadingTactic(
    reading_tactic: CreateReadingTacticInput
  ): Promise<void> {
    const { data } = await axios.get("/api/auth");
    await this.client
      .post<CreateReadingTacticInput>(
        `/api/v1/reading_tactics`,
        { reading_tactic },
        {
          headers: data,
        }
      )
      .catch((error) => {
        throw error.response.status;
      });
  }
}

export function newReadingTacticRepository(
  client: AxiosInstance
): ReadingTacticRepository {
  return new OrganizationRepositoryImpl(client);
}
